<template>
	<div class="auth-shell">
		<div class="auth-shell__brand">
			<span
				aria-hidden="true"
				class="auth-shell__mark">
				<FontAwesomeIcon icon="fa-solid fa-file-invoice" />
			</span>
			<span class="auth-shell__name">Računi</span>
		</div>
		<slot />
	</div>
</template>

<script setup lang="ts">
import FontAwesomeIcon from '@/components/FontAwesomeIcon.vue'
</script>

<style scoped lang="scss">
// The signed-out pages: the app's name above one centred card, on a softly tinted page.
.auth-shell {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 24px;
	min-height: 100vh;
	width: 100%;
	padding: 32px 16px;
	background:
		radial-gradient(
			ellipse 80% 50% at 50% -10%,
			color-mix(in srgb, var(--p-primary-400) 18%, transparent),
			transparent
		),
		var(--p-surface-50);

	@media (prefers-color-scheme: dark) {
		background:
			radial-gradient(
				ellipse 80% 50% at 50% -10%,
				color-mix(in srgb, var(--p-primary-500) 16%, transparent),
				transparent
			),
			var(--p-surface-950);
	}

	.auth-shell__brand {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.auth-shell__mark {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 40px;
		border-radius: 11px;
		background: linear-gradient(135deg, var(--p-primary-500), var(--p-primary-700));
		color: #ffffff;
		font-size: 19px;
		box-shadow: 0 4px 12px rgba(4, 120, 87, 0.25);
	}

	.auth-shell__name {
		font-size: 22px;
		font-weight: 650;
		letter-spacing: -0.02em;
		color: var(--p-text-color);
	}

	:deep(.p-card) {
		width: 100%;
		max-width: 420px;
		box-shadow:
			0 1px 2px rgba(15, 23, 42, 0.04),
			0 8px 24px rgba(15, 23, 42, 0.06);
	}

	:deep(.p-card-body) {
		padding: 28px;
	}

	:deep(.p-card-title) {
		font-size: 18px;
	}
}
</style>
